export {
  StaticMarketLegacy,
  StaticMarketsLegacy,
  StaticMarket_3_0_0,
} from "./static-markets";
export type { StaticMarketAssetLegacy } from "./static-markets";

export {
  RecordWithDefaultValue,
  getValueFromRecord,
  getDefaultValueFromRecord,
  createRecord,
} from "./record-with-default-value";
export { assetKeysLegacy } from "./types";
export type {
  PotentialValue,
  AssetKeyLegacy,
  CollateralType,
  SubsetOf,
  DeepPartial,
  TrueKeys,
} from "./types";
export { LiquidationPriceLegacy } from "./types";
export {
  ChecksumAddress,
  isChecksumAddress,
  getChecksumAddressOrThrow,
  checksumAddressEq,
  getChecksumAddressOrNull,
  CHECKSUM_ADDRESS_ZERO,
} from "./checksum-address";
export {
  providers,
  toClientProvider,
  toServerProvider,
  toSigningProvider,
  toFallbackProvider,
  STATUS_URL,
} from "./provider";
export type {
  ProviderKey,
  ClientProvider,
  ServerProvider,
  SigningProvider,
  ProviderPriority,
} from "./provider";

export {
  MerklRewardLegacy,
  LendingMerklRewardLegacy,
  MerklReward,
  CollateralMerklReward,
  ProtectedMerklReward,
  DebtMerklReward,
  BaseMerklReward,
} from "./merkl";
export type {
  EncodedMerklRewardLegacy,
  CollateralMerklRewardEncoded,
  ProtectedMerklRewardEncoded,
  DebtMerklRewardEncoded,
  BaseMerklRewardEncoded,
} from "./merkl";

export {
  PositionTypeLegacy,
  PositionType,
  PointsInfo,
  positionTypes,
  PositionReward,
} from "./position";
export { LINKS } from "./links";

export {
  BaseError,
  ScriptError,
  BaseServerError,
  ServerError,
  BaseClientError,
  ClientError,
  RateLimitError,
  NotFoundError,
} from "./error";
export type {
  BaseErrorParams,
  BaseServerParams,
  BaseClientParams,
} from "./error";

export {
  Address,
  GraphAddress,
  makeAddressSync,
  ADDRESS_ZERO,
  makeAddressRecordSync,
  makeAddressArraySync,
  isAddress,
} from "./address";

export {
  Usd,
  makeUsd,
  USD_DECIMALS,
  UsdFromBigInt,
  USD_ONE,
  USD_ZERO,
} from "./usd";

export { Amount, makeAmount, AMOUNT_ZERO, AmountFromBigInt } from "./amount";

export {
  Percent,
  PercentFromSelf,
  PercentFromBigInt,
  PERCENT_DECIMALS,
  makePercent,
  PERCENT_ZERO,
  PERCENT_ONE_HUNDRED,
  PERCENT_FACTOR,
} from "./percent";

export {
  ProtocolKey,
  protocolKeys,
  protocolMap,
  isProtocolKey,
  getProtocol,
  ProtocolKeyService,
  ProtocolKeySlug,
  ProdProtocolKey,
  prodProtocolKeys,
  isProdProtocolKey,
  ProdProtocolKeyService,
  GRAPH_ENDPOINT,
  ProtocolState,
  ProtocolStateService,
  isRuntimeProtocolKey,
} from "./protocol";

export { WarningConfig, WarningKey, warningKeys } from "./market";
export type { WarningConfigEncoded } from "./market";

export { MarketMeta } from "./market/market-meta";
export type { MarketMetaEncoded } from "./market/market-meta";

export { MarketUserState } from "./market/market-user-state";
export type { MarketUserStateEncoded } from "./market/market-user-state";

export {
  MarketChainUid,
  MarketChainUidFromString,
} from "./market/market-chain-uid";
export type {
  MarketChainUidEncoded,
  MarketChainUidFromStringEncoded,
} from "./market/market-chain-uid";

export { MarketUid, MarketUidFromString } from "./market/market-uid";
export type {
  MarketUidEncoded,
  MarketUidFromStringEncoded,
} from "./market/market-uid";

export {
  DashboardMarket,
  SKELETON_DASHBOARD_MARKET,
} from "./market/dashboard-market";
export type { DashboardMarketEncoded } from "./market/dashboard-market";

export { StaticMarket } from "./market/static-market";
export type { StaticMarketEncoded } from "./market/static-market";

export {
  DisplayMarket,
  SKELETON_DISPLAY_MARKET,
} from "./market/display-market";
export type { DisplayMarketEncoded } from "./market/display-market";

export { MarketsByProtocol } from "./market/markets-by-protocol";
export type { MarketsByProtocolEncoded } from "./market/markets-by-protocol";

export { MarketsData } from "./market/markets-by-protocol";
export type { MarketsDataEncoded } from "./market/markets-by-protocol";

export {
  MarketsOptions,
  MarketsSort,
  MarketsSortField,
  MARKETS_PAGE_SIZE,
  SortDirection,
} from "./market/options";

export type { SortBy } from "./market/options";

export {
  MarketAsset,
  AssetKey,
  assetKeys,
  isAssetKey,
  DepositType,
  DepositMode,
  DEFAULT_DEPOSIT_MODE,
  IrmConfig,
} from "./market-asset/market-asset";

export {
  CollateralAprAsset,
  ProtectedAprAsset,
  DebtAprAsset,
} from "./market-asset/apr";

export { MarketAssetUid } from "./market-asset/market-asset-uid";
export type { MarketAssetUidEncoded } from "./market-asset/market-asset-uid";

export { MarketAssetMeta } from "./market-asset/market-asset-meta";
export type { MarketAssetMetaEncoded } from "./market-asset/market-asset-meta";

export {
  DisplayMarketAsset,
  SKELETON_DISPLAY_MARKET_ASSET,
} from "./market-asset/display-market-asset";
export type { DisplayMarketAssetEncoded } from "./market-asset/display-market-asset";

export {
  DashboardMarketAsset,
  SKELETON_DASHBOARD_MARKET_ASSET,
} from "./market-asset/dashboard-market-asset";
export type { DashboardMarketAssetEncoded } from "./market-asset/dashboard-market-asset";

export { MarketAssetUserState } from "./market-asset/market-asset-user-state";
export type { MarketAssetUserStateEncoded } from "./market-asset/market-asset-user-state";

export { ShareTokenMeta } from "./market-asset/share-token-meta";
export type { ShareTokenMetaEncoded } from "./market-asset/share-token-meta";

export { camelToKebab, kebabToCamel, CamelFromKebab } from "./string";

export { anvil, local } from "./viem";
export type { ContractType } from "./viem";

export {
  chainIds,
  isChainId,
  ChainId,
  ChainKey,
  chainKeys,
  isChainKey,
  getChainKey,
  getChain,
  getIsWrappedNative,
  chains,
  getChainKeyFromProtocol,
  getChainSlug,
  prodChainKeys,
  ProdChainKey,
  isProdChainKey,
  getProdChainKeyFromProtocol,
} from "./chain";
export type { PublicClient, Chain } from "./chain";

export {
  ChainIdLegacy,
  SupportedChainId,
  isSupportedChainId,
  createChainValueGetter,
  CHAIN_SLUG,
  SUPPORTED_CHAINS,
  DEFAULT_CHAIN_ID,
} from "./chain-legacy";
export type { SupportedChainValue } from "./chain-legacy";

export {
  PROTOCOL_INSTANCES,
  PROTOCOL_INSTANCE_PRIORITY,
  ProtocolInstance,
  getProtocolInstanceChainId,
  isRuntimeFeatureProtocolInstance,
  isProtocolInstance,
  PROTOCOL_INSTANCE_CHAIN,
  RUNTIME_PROTOCOL_INSTANCES,
  createProtocolInstanceValueGetter,
  ProtocolInstanceAsUrl,
  isRuntimeProtocolInstance,
  isFeatureProtocolInstance,
  createChecksumAddressProtocolInstanceValueOrThrow,
  isRuntimeSupportedChainId,
} from "./protocol-instance";
export type {
  ProtocolInstanceValue,
  FeatureProtocolInstance,
  FeatureProtocolInstanceValue,
  GraphProtocolInstance,
} from "./protocol-instance";

export { isEnvVarOn, getEnvVarOrWarn, getEnvVarOrThrow } from "./env";
export type { EnvVarGetter } from "./env";

export {
  PRECISION_DECIMALS,
  PRECISION_FACTOR,
  DEFAULT_DECIMALS,
  NATIVE_CURRENCY_DECIMALS,
} from "./bigint";
export type { RoundingType } from "./bigint";

export { BigIntWithDecimals } from "./bigint-with-decimals";

export type {
  TaskEitherExtractLeft,
  TaskEitherExtractRight,
} from "./fp-ts/task-either";

export type { BigNumberWithDecimals } from "./big-number-with-decimals";
export {
  fromBigIntWithDecimals,
  createBigNumberWithDecimals,
} from "./big-number-with-decimals";

export { BigNumberFromString } from "./big-number";

export {
  ChainPublicClientService,
  PublicClientService,
  PublicClientServiceFactory,
  ServerRpcConfig,
  RpcConfigService,
  createTransports,
  ScriptPublicClientServiceLive,
} from "./rpc";

export {
  RpcMetricsService,
  getRpcStats,
  BrowserRpcMetricsServiceLive,
  ScriptRpcMetricsServiceLive,
} from "./rpc-metrics";

/**
 * NOTE: server-only metrics live in `./rpc-server`, which has a runtime
 * `redis` import. It is intentionally NOT re-exported from this barrel —
 * doing so pulls `redis` (and its `net`/`tls` deps) into every client
 * bundle. Server-only callers import it directly via
 * `@silo/types/src/rpc-server` (mirrors silo-interface-v2's subpath
 * exports). `MetricsKvService`/`MetricsKvError` below are safe: `kv.ts`
 * only has a type-only `redis` import, which is erased at compile time.
 */

export {
  ChainConfig,
  ProtocolConfig,
  TokenConfig,
  MarketConfig,
  ConfigAssetPoints,
  GlobalConfig,
} from "./config";

export type {
  ChainConfigEncoded,
  ProtocolConfigEncoded,
  TokenConfigEncoded,
  MarketConfigEncoded,
  ConfigAssetPointsEncoded,
} from "./config";

export {
  KvJsonMeta,
  getLastUpdated,
  MetricsKvService,
  MetricsKvError,
} from "./kv";

export { PRECISE_DECIMALS, DEFAULT_PROTOCOL_KEY, DEFAULT_ERC20_DECIMALS } from "./constants";

export {
  TokenUid,
  TokenUidFromString,
  SKELETON_TOKEN_NAME,
  SKELETON_TOKEN_SYMBOL,
} from "./token";

export {
  PointsItem,
  PointsKey,
  pointsKeys,
  getPointsLabel,
  getPointsConfig,
} from "./points";

export { DashboardData } from "./dashboard";
export type { DashboardDataEncoded } from "./dashboard";

export { SiloData, SiloDataAsset } from "./silo/silo-data";
export type { SiloDataEncoded, SiloDataAssetEncoded } from "./silo/silo-data";

export {
  WalletKey,
  walletKeys,
  isWalletKey,
  walletMap,
  getWallet,
} from "./wallet";
export type { WalletOption } from "./wallet";

export {
  OracleKey,
  oracleKeys,
  isOracleKey,
  OracleRiskLevel,
  oracleRiskLevels,
  isOracleRiskLevel,
  NATIVE_ORACLE_KEY,
  oracleMap,
  getOracle,
  UNKNOWN_ORACLE,
} from "./oracle";

export { GlobalState, GlobalStateService } from "./global";
